module.exports = __webpack_public_path__ + "static/img/son8.eab31857.png";